import Icon, { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import React from 'react';
type SparkSvgProps = {
  width?: number | string;
  height?: number | string;
  animate?: boolean;
};
const SparkSvg: React.FC<SparkSvgProps> = ({ width, height, animate = true }) => {
  return (
    <svg
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 129 129"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        animation: animate ? 'pulse 1s infinite' : undefined,
        mask: 'linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/350% 100%',
      }}
    >
      <style>
        {`
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
        @keyframes shimmer {
          100% {
            mask-position: left
          }
        }
      `}
      </style>
      <path
        d="M110.898 61.0834L78.5479 50.2955L67.7601 17.9418C66.736 14.8605 61.6271 14.8605 60.6029 17.9418L49.8141 50.2955L17.4614 61.0834C15.9202 61.5954 14.8813 63.0363 14.8813 64.662C14.8813 66.2876 15.9202 67.7285 17.4614 68.2406L49.8141 79.0294L60.6029 111.382C61.115 112.923 62.5559 113.962 64.1815 113.962C65.8072 113.962 67.248 112.923 67.7601 111.382L78.5489 79.0294L110.898 68.2406C112.439 67.7285 113.478 66.2876 113.478 64.662C113.478 63.0363 112.438 61.5954 110.898 61.0834Z"
        fill="currentColor"
        style={{
          animation: animate ? 'shimmer 2s infinite' : undefined,
          mask: 'linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/350% 100%',
        }}
      />
      <path
        d="M126.74 15.3269L117.802 10.8598L113.33 1.91879C112.048 -0.639595 107.853 -0.639595 106.578 1.91879L102.111 10.8598L93.1691 15.3269C91.8904 15.9648 91.0835 17.274 91.0835 18.7031C91.0835 20.1331 91.8904 21.4423 93.1691 22.0792L102.111 26.5463L106.578 35.4883C107.216 36.767 108.524 37.5739 109.954 37.5739C111.384 37.5739 112.689 36.767 113.33 35.4883L117.802 26.5463L126.74 22.0792C128.018 21.4383 128.825 20.1331 128.825 18.7031C128.825 17.273 128.018 15.9687 126.74 15.3269Z"
        fill="currentColor"
        style={{
          animation: animate ? 'shimmer 2s infinite' : undefined,
          transformOrigin: '110px 19px',
          mask: 'linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/350% 100%',
        }}
      />
      <path
        d="M35.6561 106.481L26.718 102.014L22.247 93.0719C20.9644 90.5145 16.7695 90.5145 15.4948 93.0719L11.0277 102.014L2.08562 106.481C0.806926 107.118 0 108.427 0 109.857C0 111.287 0.806926 112.595 2.08562 113.233L11.0277 117.7L15.4948 126.641C16.1326 127.921 17.4408 128.728 18.8709 128.728C20.3009 128.728 21.6052 127.921 22.247 126.641L26.718 117.7L35.6561 113.233C36.9348 112.591 37.7418 111.287 37.7418 109.857C37.7418 108.427 36.9348 107.122 35.6561 106.481Z"
        fill="currentColor"
        style={{
          animation: animate ? 'shimmer 2s infinite' : undefined,
          transformOrigin: '19px 110px',
          mask: 'linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/350% 100%',
        }}
      />
    </svg>
  );
};

export const SparkIcon = ({
  animate,
  ...props
}: Partial<CustomIconComponentProps> & { animate?: boolean }) => {
  return (
    <Icon
      component={(iconProps: SparkSvgProps) => <SparkSvg {...iconProps} animate={animate} />}
      {...props}
    />
  );
};

interface SparkIconWithTextProps extends Partial<CustomIconComponentProps> {
  children?: React.ReactNode;
}

export const SparkIconWithText = ({ children, ...props }: SparkIconWithTextProps) => (
  <>
    <SparkIcon style={{ marginRight: '0.36em' }} {...props} />
    {children}
  </>
);
